<template>
    <div class="main-content">
        <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
            <transition-group name="slide-fade">
                <div v-for="alert in alerts" :key="alert.id"
                    class="toast show align-items-center border-0 shadow-lg mb-2"
                    :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
                    <div class="d-flex p-3">
                        <i :class="alert.icon" class="me-3 fs-5"></i>
                        <div class="toast-body p-0 fw-medium">
                            {{ alert.message }}
                        </div>
                        <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
                    </div>
                </div>
            </transition-group>
        </div>

        <header class="content-header mb-2 mt-n5">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb mb-0 flex-nowrap text-nowrap align-items-center"
                    style="overflow-x: auto; scrollbar-width: none;">
                    <li class="breadcrumb-item">
                        <router-link class="nav-link d-inline" to="/">Início</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link class="nav-link d-inline" to="/list-page-lead">Páginas de Captura</router-link>
                    </li>
                    <li class="breadcrumb-item active text-dark small" aria-current="page">
                        Estatísticas
                    </li>
                </ol>
            </nav>
        </header>

        <!-- Loading Global -->
        <div v-if="loadingStats && !statsData" class="text-center py-5">
            <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"></div>
            <h5 class="mt-3 text-muted">Carregando dados da página...</h5>
        </div>

        <div v-else>
            <!-- Cabeçalho e Totais -->


            <!-- Card de Filtros -->
            <div class="card p-4 shadow-subtle rounded-4 border-0 mb-4 bg-white">
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <h3 class="mb-0 fw-bold text-dark">{{ pageTitle }}</h3>
                        <p class="text-muted small mb-0">Visão geral e desempenho de captação</p>
                    </div>
                    <button class="btn btn-pmg-light" @click="fetchStatistics">
                        <i class="bi bi-arrow-clockwise me-1"></i> Atualizar Dados
                    </button>
                </div>
                <hr>
                <h6 class="fw-bold mb-3"><i class="bi bi-funnel me-2"></i>Filtros Analíticos</h6>
                <div class="row g-3">
                    <div class="col-md-3">
                        <label class="form-label small text-muted fw-bold">Origem (UTM Source)</label>
                        <select v-model="filters.utm_source" class="form-select form-control-pmg">
                            <option value="">Todas as origens</option>
                            <option value="instagram">Instagram</option>
                            <option value="facebook">Facebook</option>
                            <option value="tiktok">TikTok</option>
                            <option value="google">Google</option>
                            <option value="direct">Direct / Sem UTM</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label small text-muted fw-bold">Dispositivo</label>
                        <select v-model="filters.device_type" class="form-select form-control-pmg">
                            <option value="">Todos</option>
                            <option value="mobile">Mobile (Celular)</option>
                            <option value="desktop">Desktop (Computador)</option>
                            <option value="tablet">Tablet</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label class="form-label small text-muted fw-bold">Estado (UF)</label>
                        <input v-model="filters.state" type="text" class="form-control form-control-pmg"
                            placeholder="Ex: CE">
                    </div>
                    <div class="col-md-2">
                        <label class="form-label small text-muted fw-bold">Cidade</label>
                        <input v-model="filters.city" type="text" class="form-control form-control-pmg"
                            placeholder="Ex: Crato">
                    </div>
                    <div class="col-md-2 d-flex align-items-end">
                        <button class="btn btn-pmg-primary w-100 py-2" @click="applyFilters" :disabled="loadingStats">
                            <span v-if="loadingStats" class="spinner-border spinner-border-sm me-2"></span>
                            <i class="bi bi-search me-1" v-else></i> Filtrar
                        </button>
                    </div>
                </div>
            </div>

            <!-- Totalizadores -->
            <div class="row mb-4 g-3">
                <!-- Card 1: Total de Leads (Existente) -->
                <div class="col-md-4">
                    <div class="card p-4 shadow-subtle rounded-4 border-0 bg-primary bg-gradient text-white h-100">
                        <div class="d-flex align-items-center justify-content-between mb-3">
                            <h6 class="mb-0 fw-medium opacity-75">Total de Leads</h6>
                            <i class="bi bi-people fs-3 opacity-50"></i>
                        </div>
                        <h2 class="display-4 fw-bold mb-0">{{ totalLeads }}</h2>
                        <p class="small opacity-75 mt-2 mb-0">Leads capturados com os filtros atuais.</p>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="card p-4 shadow-subtle rounded-4 border-0 bg-success bg-gradient text-white h-100">
                        <div class="d-flex align-items-center justify-content-between mb-3">
                            <h6 class="mb-0 fw-medium opacity-75">Leads Hoje</h6>
                            <i class="bi bi-calendar-day fs-3 opacity-50"></i>
                        </div>
                        <h2 class="display-4 fw-bold mb-0">{{ leadsToday }}</h2>
                        <p class="small opacity-75 mt-2 mb-0">Cadastros realizados no dia de hoje.</p>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="card p-4 shadow-subtle rounded-4 border-0 bg-secondary bg-gradient text-white h-100">
                        <div class="d-flex align-items-center justify-content-between mb-3">
                            <h6 class="mb-0 fw-medium opacity-75">Principal Origem</h6>
                            <i class="bi bi-bullseye fs-3 opacity-50"></i>
                        </div>
                        <!-- text-truncate previne que textos de UTM muito longos quebrem o layout -->
                        <h2 class="display-5 fw-bold mb-0 text-truncate" style="max-width: 100%;">
                            {{ topSource === 'Nenhuma' ? '-' : topSource.toUpperCase() }}
                        </h2>
                        <p class="small opacity-75 mt-2 mb-0">Canal que mais converteu leads.</p>
                    </div>
                </div>
            </div>

            <!-- Gráficos -->
            <div class="row g-4">
                <!-- Gráfico UTM Source -->
                <div class="col-md-6">
                    <div class="card p-4 shadow-subtle rounded-4 border-0 h-100">
                        <h6 class="fw-bold mb-4 text-center">Origem do Tráfego (UTM Source)</h6>
                        <div v-if="hasUtmData" class="chart-container">
                            <Doughnut :data="utmChartData" :options="pieOptions" />
                        </div>
                        <div v-else class="text-center py-5 text-muted">
                            <i class="bi bi-pie-chart fs-1 opacity-25"></i>
                            <p class="mt-2">Dados insuficientes para este gráfico.</p>
                        </div>
                    </div>
                </div>

                <!-- Gráfico de Dispositivos -->
                <div class="col-md-6">
                    <div class="card p-4 shadow-subtle rounded-4 border-0 h-100">
                        <h6 class="fw-bold mb-4 text-center">Tipos de Dispositivos</h6>
                        <div v-if="hasDeviceData" class="chart-container">
                            <Pie :data="deviceChartData" :options="pieOptions" />
                        </div>
                        <div v-else class="text-center py-5 text-muted">
                            <i class="bi bi-phone fs-1 opacity-25"></i>
                            <p class="mt-2">Dados insuficientes para este gráfico.</p>
                        </div>
                    </div>
                </div>

                <!-- Gráfico de Cidades (Barras Horizontais) -->
                <div class="col-12">
                    <div class="card p-4 shadow-subtle rounded-4 border-0">
                        <h6 class="fw-bold mb-4">Top 5 Cidades com Mais Leads</h6>
                        <div v-if="hasCityData" class="chart-container-large">
                            <Bar :data="cityChartData" :options="barOptions" />
                        </div>
                        <div v-else class="text-center py-5 text-muted">
                            <i class="bi bi-bar-chart fs-1 opacity-25"></i>
                            <p class="mt-2">A geolocalização não encontrou cidades suficientes.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/services/api';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale, BarElement } from 'chart.js';
import { Pie, Doughnut, Bar } from 'vue-chartjs';

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale, BarElement);

export default {
    inject: ['globalLoading'],
    components: {
        Pie,
        Doughnut,
        Bar
    },
    data() {
        return {
            pageId: this.$route.params.id,
            alerts: [],
            loadingStats: false,
            statsData: null,
            pageTitle: 'Carregando...',
            totalLeads: 0,
            leadsToday: 0,
            topSource: 'Nenhuma',
            // Filtros
            filters: {
                utm_source: '',
                device_type: '',
                state: '',
                city: ''
            },

            // Dados dos Gráficos (Formato Chart.js)
            utmChartData: {
                labels: [],
                datasets: [{ data: [], backgroundColor: [] }]
            },
            deviceChartData: {
                labels: [],
                datasets: [{ data: [], backgroundColor: [] }]
            },
            cityChartData: {
                labels: [],
                datasets: [{ label: 'Leads', data: [], backgroundColor: [] }]
            },

            // Opções Visuais do Chart.js
            pieOptions: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { position: 'bottom' }
                }
            },
            barOptions: {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: 'y', // Isso faz o gráfico de barras ficar horizontal
                plugins: {
                    legend: { display: false }
                },
                scales: {
                    x: { ticks: { stepSize: 1 } } // Para não mostrar números quebrados nos leads
                }
            }
        }
    },
    computed: {
        hasUtmData() {
            return this.utmChartData.datasets[0].data.length > 0;
        },
        hasDeviceData() {
            return this.deviceChartData.datasets[0].data.length > 0;
        },
        hasCityData() {
            return this.cityChartData.datasets[0].data.length > 0;
        }
    },
    mounted() {
        this.fetchStatistics();
    },
    methods: {
        async fetchStatistics() {
            this.globalLoading.show('Carregando dados...');
            this.loadingStats = true;
            try {
                const response = await api.get(`/capture-pages/${this.pageId}/statistics`, {
                    params: this.filters
                });

                const payload = response.data.data;
                this.statsData = payload;
                this.pageTitle = payload.page_title;
                this.totalLeads = payload.total_leads;
                this.leadsToday = payload.leads_today || 0;
                this.topSource = payload.top_source || 'Nenhuma';

                this.formatChartsData(payload.charts);

            } catch (error) {
                console.error("Erro ao carregar estatísticas:", error);
                this.showAlert('Falha ao carregar as estatísticas da página.', 'error');
            } finally {
                this.loadingStats = false;
                this.globalLoading.hide();
            }
        },

        applyFilters() {
            this.fetchStatistics();
        },

        formatChartsData(charts) {
            // Paletas de Cores do PMG
            const colors1 = ['#561569', '#8338ec', '#ff006e', '#fb5607', '#ffbe0b'];
            const colors2 = ['#3a86ff', '#06d6a0', '#ef476f'];

            // 1. Formata UTM Sources
            const utmKeys = Object.keys(charts.utm_sources || {});
            const utmVals = Object.values(charts.utm_sources || {});

            // É necessário reatribuir o objeto inteiro para garantir a reatividade no vue-chartjs
            this.utmChartData = {
                labels: utmKeys.map(k => (k === '' || k === null) ? 'Direto' : k.toUpperCase()),
                datasets: [{
                    data: utmVals,
                    backgroundColor: colors1.slice(0, utmVals.length)
                }]
            };

            // 2. Formata Devices
            const devKeys = Object.keys(charts.devices || {});
            const devVals = Object.values(charts.devices || {});

            this.deviceChartData = {
                labels: devKeys.map(k => k ? k.toUpperCase() : 'DESCONHECIDO'),
                datasets: [{
                    data: devVals,
                    backgroundColor: colors2.slice(0, devVals.length)
                }]
            };

            // 3. Formata Cidades
            const cities = charts.top_cities || [];

            this.cityChartData = {
                labels: cities.map(c => `${c.city} - ${c.state}`),
                datasets: [{
                    label: 'Leads Capturados',
                    data: cities.map(c => c.total),
                    backgroundColor: ['#561569'] // Cor padrão do projeto RMR
                }]
            };
        },

        showAlert(message, type = 'success') {
            const id = Date.now();
            let icon = 'bi-check-circle-fill';
            if (type === 'danger') icon = 'bi-exclamation-circle-fill';
            if (type === 'error') icon = 'bi-x-circle-fill';

            this.alerts.push({ id, message, type, icon });
            setTimeout(() => this.removeAlert(id), 8000);
        },

        removeAlert(id) {
            this.alerts = this.alerts.filter(a => a.id !== id);
        }
    }
}
</script>

<style scoped>
/* Aproveitando os estilos do seu layout PMG */
.main-content {
    background-color: #f8fafc;
    min-height: 100vh;
    padding: 2rem;
    font-family: 'Inter', sans-serif;
}

.card {
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
}

.btn-pmg-primary {
    background: #561569;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-weight: 500;
}

.btn-pmg-primary:hover {
    background: #451054;
}

.btn-pmg-light {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    color: #64748b;
    padding: 10px 20px;
}

.form-control-pmg {
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 10px 12px;
}

.bg-primary {
    background-color: #561569 !important;
}

/* O Chart.js precisa que o container pai tenha um tamanho definido quando maintainAspectRatio é falso */
.chart-container {
    position: relative;
    height: 300px;
    width: 100%;
}

.chart-container-large {
    position: relative;
    height: 350px;
    width: 100%;
}

/* Transições dos Toasts */
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s ease;
}

.slide-fade-enter-from {
    transform: translateX(100px);
    opacity: 0;
}

.slide-fade-leave-to {
    opacity: 0;
    transform: scale(0.9);
}
</style>